function confirmDelete(productid, isGrouppedItem = false) {
    let confirmDialog = "Bitte bestätigen Sie das Löschen dieses Artikels aus Ihrem aktuellen Warenkorb.";
    if(isGrouppedItem) {
        confirmDialog = "<b>Bitte beachten Sie</b>: Der Artikel ist eine Kombination aus Produkt(en) und Gutschein. Beim Löschen werden auch alle anhängigen Artikel gelöscht.<br /><br />" + confirmDialog;
    }
    $.confirm({
        title: "Artikel löschen",
        content: confirmDialog,
        buttons: {
            ok: function () {},
            schliessen: function () {}
        },
        onAction: function (btnName) {
            switch(btnName) {
                case "ok":
                    location.href = "/warenkorb/delete_cart_item?id=" + productid;
                    break;
                default:
                    console.log("Der Vorgang wurde nicht bestätigt.");
            }
        }
    });
}